import React from 'react';
import { makeStyles } from '@material-ui/core';

import { escapeText } from '@root/utils/text.utils';

const useStyles = makeStyles(() => ({
  headline: {
    color: '#1C1BA8',
    fontFamily: 'Arial',
    fontSize: '1.125rem',
    overflow: 'wrap',
    width: '90%',
  },
  content: {
  },
}));

const GoogleAdPreview = ({
  content,
  onTextSelect = () => null,
}) => {
  const classes = useStyles();

  const [selectedField, setSelectedField] = React.useState(null);

  const onFieldSelect = (field) => () => setSelectedField(field);

  const {
    description1,
    description2,
    headline1,
    headline2,
    headline3,
  } = content;

  const descriptions = [description1, description2]
    .map(((d, i) => ({ description: d, number: i + 1 })))
    .filter((d) => !!d.description);

  const onContentSelect = () => {
    const text = escapeText(window.getSelection().toString());

    if (!text || !escapeText(content[selectedField]).includes(text)) {
      onTextSelect(null);
      return;
    }

    onTextSelect({
      text,
      field: selectedField,
    });
  };

  return (
    <div onMouseUp={onContentSelect}>
      <div className={classes.headline}>
        <span onMouseMove={onFieldSelect('headline1')}>
          {`${headline1} `}
        </span>
        |
        <span onMouseMove={onFieldSelect('headline2')}>
          {` ${headline2} `}
        </span>
        |
        <span onMouseMove={onFieldSelect('headline3')}>
          {` ${headline3}`}
        </span>
      </div>
      <div style={{ marginTop: 10 }}>
        {descriptions.map((d) => (
          <div
            key={d.description}
            style={{
              fontFamily: 'Arial',
              marginTop: '-0.675rem',
              paddingBottom: '1rem',
            }}
            onMouseMove={onFieldSelect(`description${d.number}`)}
          >
            <span>{d.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoogleAdPreview;
